import type { PortalAPIError } from '@portal/portal-api'

import { env } from '@/shared/config'
import type { Translation } from '@/shared/lib/i18n'

export function getPortalAPIErrorMessage(error: PortalAPIError, i18n: Translation): string {
    const errorMessageTranslation = portalAPIErrorTranslations[error.code]

    return typeof errorMessageTranslation === 'function' ? errorMessageTranslation(i18n) : i18n[errorMessageTranslation]
}

const portalAPIErrorTranslations: Record<PortalAPIError['code'], keyof Translation | ((i18n: Translation) => string)> =
    {
        account_already_exist: 'TEXT_EXISTING_USER_INFORM',
        account_disabled: 'TEXT_ACCOUNT_DISABLED',
        account_link_already_exist: 'TEXT_TOAST_ACCOUNT_OCCUPIED',
        account_link_not_found: 'TEXT_ERROR_ACCOUNT_NOT_FOUND',
        account_not_found: 'TEXT_ERROR_ACCOUNT_NOT_FOUND',
        account_email_consent_error: 'TEXT_TOAST_NEWSLETTER_SUBSCRIBE_ERROR',
        bad_request: 'TEXT_TOAST_FAIL',
        db_error: 'TEXT_TOAST_TRY_LATER',
        deploy_error: 'TEXT_TOAST_TRY_LATER',
        doom_owner_not_available: 'TEXT_TOAST_TRY_LATER',
        email_account_already_exist: 'TEXT_EXISTING_USER_INFORM',
        email_already_changed: 'TEXT_TOAST_FAIL',
        email_maybe_undeliverable: 'TEXT_ERROR_EMAIL_INVALID',
        email_not_available: 'EMAIL_CHANGE_ERROR__OCCUPIED',
        email_not_match: 'TEXT_TOAST_FAIL',
        email_send_failed: 'TEXT_TOAST_FAIL',
        email_undeliverable: 'TEXT_ERROR_EMAIL_INVALID',
        encode_error: 'TEXT_TOAST_FAIL',
        image_save_failed: 'TEXT_TOAST_TRY_LATER',
        internal_error: 'TEXT_TOAST_FAIL',
        internal_request_failed: 'TEXT_TOAST_TRY_LATER',
        invalid_access_token: 'TEXT_TOAST_FAIL',
        invalid_access_code: 'TEXT_TOAST_FAIL',
        invalid_account: 'TEXT_TOAST_FAIL',
        invalid_argument: 'TEXT_TOAST_FAIL',
        invalid_avatar: 'TEXT_TOAST_TRY_LATER',
        invalid_currency: 'TEXT_TOAST_TRY_LATER',
        invalid_email: 'TEXT_ERROR_EMAIL_INVALID',
        invalid_image_bound: 'TEXT_TOAST_FAIL',
        invalid_image_decoding: 'TEXT_TOAST_FAIL',
        invalid_image_encoding: 'TEXT_TOAST_FAIL',
        invalid_image_mime: 'TEXT_TOAST_FAIL',
        invalid_image_nsfw_score: 'TEXT_TOAST_FAIL',
        invalid_image_size: 'TEXT_TOAST_FAIL',
        invalid_register_info: 'TEXT_TOAST_FAIL',
        invalid_session: 'TEXT_TOAST_FAIL',
        invalid_user_nick: 'TEXT_ERROR_NICK_INVALID',
        invalid_verify_challenge: 'TEXT_TOAST_FAIL',
        invalid_verify_factor: 'TEXT_TOAST_FAIL',
        maintenance: 'TEXT_TOAST_TRY_LATER',
        password_not_match: 'TEXT_PASSWORD_INCORRECT',
        password_too_long: 'TEXT_ERROR_PASSWORD_LONG',
        password_too_short: (i18n: Translation) =>
            i18n.TEXT_ERROR_PASSWORD_SHORT.replace('{number01}', env.ACCOUNT_PASSWORD_MIN_LEN.toString()),
        password_too_simple: 'TEXT_ERROR_PASSWORD_WEAK',
        platform_account_already_exist: 'TEXT_EXISTING_USER_INFORM',
        platform_already_linked: 'TEXT_TOAST_ACCOUNT_OCCUPIED',
        player_disabled: 'TEXT_ACCOUNT_DISABLED',
        player_not_found: 'TEXT_ERROR_ACCOUNT_NOT_FOUND',
        unauthorized: 'TEXT_TOAST_FAIL',
        verify_challenge_not_available: 'TEXT_TOAST_TRY_LATER',
        worker_error: 'TEXT_TOAST_TRY_LATER',
        worker_not_found: 'TEXT_TOAST_TRY_LATER',
        worker_not_available: 'TEXT_TOAST_TRY_LATER',
        client_not_available: 'TEXT_TOAST_TRY_LATER',

        transport_error: 'TEXT_TOAST_TRY_LATER',
        invalid_response: 'TEXT_TOAST_TRY_LATER',
        unknown_error: 'TEXT_TOAST_TRY_LATER',
    }
